/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { createDashboardMeDashboardsPost } from '../fn/user-dashboards/create-dashboard-me-dashboards-post';
import { CreateDashboardMeDashboardsPost$Params } from '../fn/user-dashboards/create-dashboard-me-dashboards-post';
import { deleteDashboardMeDashboardsDashboardIdDelete } from '../fn/user-dashboards/delete-dashboard-me-dashboards-dashboard-id-delete';
import { DeleteDashboardMeDashboardsDashboardIdDelete$Params } from '../fn/user-dashboards/delete-dashboard-me-dashboards-dashboard-id-delete';
import { getDashboardMeDashboardsDashboardIdGet } from '../fn/user-dashboards/get-dashboard-me-dashboards-dashboard-id-get';
import { GetDashboardMeDashboardsDashboardIdGet$Params } from '../fn/user-dashboards/get-dashboard-me-dashboards-dashboard-id-get';
import { listDashboardsMeDashboardsGet } from '../fn/user-dashboards/list-dashboards-me-dashboards-get';
import { ListDashboardsMeDashboardsGet$Params } from '../fn/user-dashboards/list-dashboards-me-dashboards-get';
import { updateDashboardMeDashboardsDashboardIdPatch } from '../fn/user-dashboards/update-dashboard-me-dashboards-dashboard-id-patch';
import { UpdateDashboardMeDashboardsDashboardIdPatch$Params } from '../fn/user-dashboards/update-dashboard-me-dashboards-dashboard-id-patch';
import { BackendUserDashboardListResponseDto } from '../models/backend-user-dashboard-list-response-dto';
import { BackendUserDashboardResponseDto } from '../models/backend-user-dashboard-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiUserDashboardsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listDashboardsMeDashboardsGet()` */
  static readonly ListDashboardsMeDashboardsGetPath = '/me/dashboards';

  /**
   * Список дашбордов текущего пользователя.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listDashboardsMeDashboardsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDashboardsMeDashboardsGet$Response(
    params?: ListDashboardsMeDashboardsGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserDashboardListResponseDto>> {
    return listDashboardsMeDashboardsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Список дашбордов текущего пользователя.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listDashboardsMeDashboardsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDashboardsMeDashboardsGet(
    params?: ListDashboardsMeDashboardsGet$Params,
    context?: HttpContext,
  ): Observable<BackendUserDashboardListResponseDto> {
    return this.listDashboardsMeDashboardsGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserDashboardListResponseDto>): BackendUserDashboardListResponseDto => r.body),
    );
  }

  /** Path part for operation `createDashboardMeDashboardsPost()` */
  static readonly CreateDashboardMeDashboardsPostPath = '/me/dashboards';

  /**
   * Создать дашборд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDashboardMeDashboardsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDashboardMeDashboardsPost$Response(
    params: CreateDashboardMeDashboardsPost$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
    return createDashboardMeDashboardsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать дашборд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDashboardMeDashboardsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDashboardMeDashboardsPost(
    params: CreateDashboardMeDashboardsPost$Params,
    context?: HttpContext,
  ): Observable<BackendUserDashboardResponseDto> {
    return this.createDashboardMeDashboardsPost$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserDashboardResponseDto>): BackendUserDashboardResponseDto => r.body),
    );
  }

  /** Path part for operation `getDashboardMeDashboardsDashboardIdGet()` */
  static readonly GetDashboardMeDashboardsDashboardIdGetPath = '/me/dashboards/{dashboard_id}';

  /**
   * Получить дашборд по id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashboardMeDashboardsDashboardIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboardMeDashboardsDashboardIdGet$Response(
    params: GetDashboardMeDashboardsDashboardIdGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
    return getDashboardMeDashboardsDashboardIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить дашборд по id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDashboardMeDashboardsDashboardIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboardMeDashboardsDashboardIdGet(
    params: GetDashboardMeDashboardsDashboardIdGet$Params,
    context?: HttpContext,
  ): Observable<BackendUserDashboardResponseDto> {
    return this.getDashboardMeDashboardsDashboardIdGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserDashboardResponseDto>): BackendUserDashboardResponseDto => r.body),
    );
  }

  /** Path part for operation `deleteDashboardMeDashboardsDashboardIdDelete()` */
  static readonly DeleteDashboardMeDashboardsDashboardIdDeletePath = '/me/dashboards/{dashboard_id}';

  /**
   * Удалить дашборд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDashboardMeDashboardsDashboardIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDashboardMeDashboardsDashboardIdDelete$Response(
    params: DeleteDashboardMeDashboardsDashboardIdDelete$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return deleteDashboardMeDashboardsDashboardIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить дашборд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDashboardMeDashboardsDashboardIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDashboardMeDashboardsDashboardIdDelete(
    params: DeleteDashboardMeDashboardsDashboardIdDelete$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.deleteDashboardMeDashboardsDashboardIdDelete$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `updateDashboardMeDashboardsDashboardIdPatch()` */
  static readonly UpdateDashboardMeDashboardsDashboardIdPatchPath = '/me/dashboards/{dashboard_id}';

  /**
   * Обновить title/layout/filters (project_id и scenario_id immutable).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDashboardMeDashboardsDashboardIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDashboardMeDashboardsDashboardIdPatch$Response(
    params: UpdateDashboardMeDashboardsDashboardIdPatch$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
    return updateDashboardMeDashboardsDashboardIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить title/layout/filters (project_id и scenario_id immutable).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDashboardMeDashboardsDashboardIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDashboardMeDashboardsDashboardIdPatch(
    params: UpdateDashboardMeDashboardsDashboardIdPatch$Params,
    context?: HttpContext,
  ): Observable<BackendUserDashboardResponseDto> {
    return this.updateDashboardMeDashboardsDashboardIdPatch$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserDashboardResponseDto>): BackendUserDashboardResponseDto => r.body),
    );
  }
}
